import { faUser } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

import { ButtonUserStyled } from '../Styles';

export const ButtonUser = ({ disabled }) => (
  <ButtonUserStyled icon={faUser} disabled={disabled} />
);

ButtonUser.propTypes = {
  disabled: PropTypes.bool,
};
